import Cards from 'containers/Cards';
import Newsletter from 'containers/Education/MainNewsletter';
import EducationBanner from 'containers/Education/EducationBanner';
import CheckTools from 'containers/Education/CheckTools';
import EducationArticle from 'containers/Education/EducationArticle';
import AcademicArchive from 'containers/Education/AcademicArchive';
import Calendar from 'containers/Education/Calendar';
import EducationSlider from 'containers/Education/EducationSlider';
import MainNews from 'containers/Education/MainNews';
import CheckedNews from 'containers/Education/CheckedNews';
import NewsletterCTA from 'containers/Education/NewsletterCTA';

import StoryblokClient from 'storyblok-js-client';
import { token } from '_config';
import { Container, Row } from 'components/atoms/Grid';
import Ads from 'components/organisms/Ads';

let Storyblok = new StoryblokClient({
    accessToken: token
});

function createMarkup(storyblokHTML) {
    return {
        __html: Storyblok.richTextResolver.render(storyblokHTML)
    };
}

export const RichTextField = ({ data }) => {
    return <div dangerouslySetInnerHTML={createMarkup(data)} />;
};

const Components = {
    main_news: props => <MainNews {...props} />,
    check_tools: props => <CheckTools {...props} />,
    education_article: props => <EducationArticle {...props} />,
    calendar: props => <Calendar {...props} />,
    newsletter: props => <Newsletter {...props} />,
    education_slider: props => <EducationSlider {...props} />,
    projects_cards: props => <Cards {...props} />,
    academic_archive: props => <AcademicArchive {...props} />,
    education_banner: props => <EducationBanner {...props} />,
    checked_news_education: props => <CheckedNews {...props} />,
    call_to_action_newsletter: props => <NewsletterCTA {...props} />,
    advertising: props => (
        <Container>
            <Row justifyContent="center" pt="5 7" pb="5 12">
                <Ads width={'970'} height={'250'} mobileWidth={'300'} mobileHeight={'250'} {...props} />
            </Row>
        </Container>
    )
};

function Item(item) {
    if (!Components[item.component]) return <div>{item.component}</div>;

    return Components[item.component](item);
}

export default Item;
